import React, { useContext, useEffect } from 'react'
import { Switch, useHistory, useParams, useRouteMatch } from 'react-router-dom'
import Dashboard from '../../dashboard/components'
import Subscriptions from '../../subscriptions/components'
import Accounts from '../../accounts/components'
import Reports from '../../reports/components'
import ReportDetails from '../../reports/components/ReportDetails'
import { useTranslation } from 'react-i18next'
import NotFound404 from '../../../global/nav/components/NotFound404'
import PartnerRoute from './PartnerRoute'
import { AppContext } from '../../../global'
import { Params } from '../../types'
import * as actions from '../../../global/partner/store/actions'
import { Partner } from '../../../global/partner/store/store'

function PartnerRoutes() {
  const { state, execute } = useContext(AppContext)
  const history = useHistory()
  const { t } = useTranslation(['navigation', 'global'])
  const { path } = useRouteMatch()
  const { partners } = state.auth
  const { partnerId } = useParams() as Params

  useEffect(
    () => {
      const currentPartner = partners.find((p: Partner) => p.id === partnerId)
      if (currentPartner) {
        execute(actions.selectPartner(currentPartner))
      } else {
        //TODO what do we do here?
        history.push('/')
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [partnerId]
  )

  return (
    <div>
      <Switch>
        <PartnerRoute exact path={path} component={Dashboard} title={t('dashboard')} />
        <PartnerRoute exact path={`${path}/subscriptions`} component={Subscriptions} title={t('subscriptions')} />
        <PartnerRoute exact path={`${path}/accounts`} component={Accounts} title={t('accounts')} />
        <PartnerRoute exact path={`${path}/reports`} component={Reports} title={t('reports')} />
        <PartnerRoute exact path={`${path}/reports/:id`} component={ReportDetails} title={t('report_details')} />
        <PartnerRoute exact component={NotFound404} />
      </Switch>
    </div>
  )
}

export default PartnerRoutes
